export default {
  header: 'Informacje o {0}',
  loadData: 'Załadunek',
  load: 'Załadunek {0}',
  orderNo: 'Nr zlecenia',
  partNo: 'Nr części',
  partDesc: 'Opis części',
  targetQuantity: 'Ilość docelowa',
  actualQuantity: 'Ilość rzeczywista',
  singleWeightText: 'Waga jednostkowa',
  totalWeightText: 'Waga całkowita',
  productionOutput: 'Wynik produkcji',
  quantityBreak: 'Ilość pęknięć',
  quantityCrack: 'Ilość rys',
  quantityNOK: 'Ilość NOK',
  quantityOK: 'Ilość OK',
  rightCycleTimeSeconds: 'Prawidłowy czas cyklu [s]',
  qmData: 'Dane QS',
  restData: 'Dane rusztu',
  grateNo: 'Nr rusztu',
  spsNo: 'Nr SPS',
  startTime: 'Czas rozpoczęcia',
  endTime: 'Czas zakończenia',
  previousEndTime: 'Poprzedni czas zakończenia',
  id: 'ID',
  treatment: 'Obróbka',
  grateType: 'Typ rusztu',
  zoneTimes: 'Czasy stref',
  zoneEntranceTime: 'Czas wjazdu do strefy',
  zoneExitTime: 'Czas wyjazdu ze strefy',
  zone1EntryTime: 'Czas wejścia strefy 1',
  zone1ExitTime: 'Czas wyjścia strefy 1',
  zone2EntryTime: 'Czas wejścia strefy 2',
  zone2ExitTime: 'Czas wyjścia strefy 2',
  specialColor: 'Kolor specjalny',
};
